import ReactDOM from 'react-dom/client';
import ConfirmModal from '../components/common/modal/ConfirmModal';

const OVERLAP_CONFIRM_CODE = 'SCHEDULE_OVERLAP_CONFIRM';
const CONFIRM_QUESTION = '그래도 저장하시겠습니까?';
const CONFIRM_COLOR = '#4AB3BC';

// 서버 겹침 문구의 괄호 설명이 문장 중간에서 끊기지 않게 괄호 앞에서 줄을 바꾼다.
//   "해당 시간(20:00~20:50)에 담당자의 수업(나엄준 회원 수업)이 있습니다."
//     → "해당 시간(20:00~20:50)에 담당자의 수업" / "(나엄준 회원 수업)이 있습니다."
//   "해당 시간(20:00~20:50)에 이 회원의 수업이 있습니다. (강사 홍길동)"
//     → "해당 시간(20:00~20:50)에 이 회원의 수업이 있습니다." / "(강사 홍길동)"
const formatOverlapMessage = message =>
  String(message || '')
    .replace(/(\S)(\([^()]*\)(?:이|가) 있습니다)/, '$1\n$2')
    .replace(/(있습니다\.) (\([^()]*\))$/, '$1\n$2');

// 화면 상태와 무관하게 어디서든(일반 함수 포함) 띄울 수 있도록 별도 root 에 ConfirmModal 을 그린다.
const askConfirm = message =>
  new Promise(resolve => {
    const container = document.createElement('div');
    document.body.appendChild(container);
    const root = ReactDOM.createRoot(container);
    const finish = ok => {
      resolve(ok);
      // 클릭 핸들러 안에서 바로 unmount 하면 React 경고가 나서 한 틱 뒤에 정리한다
      setTimeout(() => {
        root.unmount();
        container.remove();
      });
    };
    root.render(
      <ConfirmModal
        open
        message={`${formatOverlapMessage(message)}\n${CONFIRM_QUESTION}`}
        highlightText={CONFIRM_QUESTION}
        highlightColor={CONFIRM_COLOR}
        cancelText="취소"
        confirmText="저장"
        confirmColor={CONFIRM_COLOR}
        width="520px"
        onClose={() => finish(false)}
        onConfirm={() => finish(true)}
      />,
    );
  });

// 상담이 낀 일정 겹침이면 서버가 409 SCHEDULE_OVERLAP_CONFIRM 으로 묻는다.
// 사용자가 확인하면 같은 요청을 force=true 로 한 번 더 보낸다. send = force => Promise
// 취소하면 silent 표식 에러를 던진다(호출부 catch·mutationCache 에서 토스트 없이 끝내고, 화면은 실패와 같이 되돌린다)
// onConflict 가 있으면 묻는 동안 겹친 카드를 보여줄 수 있게 conflict 를 넘긴다.
export const withOverlapConfirm = async (send, { onConflict } = {}) => {
  try {
    return await send(false);
  } catch (error) {
    const data = error?.response?.data;
    if (data?.errorCode !== OVERLAP_CONFIRM_CODE) throw error;
    onConflict?.(data.conflict);
    if (!(await askConfirm(data.message))) {
      const cancelled = new Error('SCHEDULE_OVERLAP_CANCELLED');
      cancelled.silent = true;
      throw cancelled;
    }
    return send(true);
  }
};

